import React, { useState } from "react";
import axios from "axios";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "../ui/dialog";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Label } from "../ui/label";

// Member Login Dialog Component
const MemberLoginDialog = ({ isOpen, onClose, onLogin, onForgotPassword }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    
    try {
      await onLogin(email, password);
      setEmail("");
      setPassword("");
      onClose();
    } catch (err) {
      const errorDetail = err.response?.data?.detail;
      if (errorDetail === "Incorrect email or password") {
        setError("Incorrect email or password. Please check your credentials and try again.");
      } else if (errorDetail === "Account not activated") {
        setError("Your account is not activated. Please check your email for the activation link.");
      } else {
        setError(errorDetail || "Login failed. Please try again.");
      }
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="bg-slate-800 border-slate-700">
        <DialogHeader>
          <DialogTitle className="text-white">Member Login</DialogTitle>
          <DialogDescription className="text-slate-400">
            Sign in to access your dashboard and track your progress
          </DialogDescription>
        </DialogHeader>
        <form onSubmit={handleLogin} className="space-y-4">
          <div>
            <Label htmlFor="login-email" className="text-slate-200">Email</Label>
            <Input
              id="login-email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="your.email@example.com"
              required
              className="bg-slate-700 border-slate-600 text-white placeholder:text-slate-400"
              data-testid="login-email-input"
            />
          </div>
          <div>
            <Label htmlFor="login-password" className="text-slate-200">Password</Label>
            <Input
              id="login-password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••"
              required
              className="bg-slate-700 border-slate-600 text-white placeholder:text-slate-400"
              data-testid="login-password-input"
            />
          </div>
          {error && (
            <div className="text-red-400 text-sm bg-red-500/20 border border-red-500/30 p-2 rounded">{error}</div>
          )}
          <div className="flex items-center justify-between">
            <button
              type="button"
              onClick={() => {
                onClose();
                onForgotPassword();
              }}
              className="text-sm text-blue-400 hover:text-blue-300 hover:underline"
              data-testid="forgot-password-link"
            >
              Forgot Password?
            </button>
            <div className="flex space-x-2">
              <Button type="button" variant="outline" onClick={onClose} disabled={loading} className="border-slate-600 text-slate-300 hover:bg-slate-700">
                Cancel
              </Button>
              <Button type="submit" disabled={loading} className="bg-blue-600 hover:bg-blue-700" data-testid="login-submit-btn">
                {loading ? "Signing in..." : "Sign In"}
              </Button>
            </div>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default MemberLoginDialog;
